import React from 'react';

import { FieldsEnum } from 'app/shared/enums';
import { NoneControl } from 'app/components/Controls/';
import { TravelFormSubmitBox } from 'app/components/TravelFormSubmitBox';
import { TravelFormNoneControlProps } from './TravelFormNoneControl.interfaces';

export default function TravelFormNoneControl(
  props: TravelFormNoneControlProps
) {
  const { questionKey } = props;

  switch (questionKey) {
    case FieldsEnum.TravelDestinationResultsForPoland:
      return <TravelFormSubmitBox {...props} />;
    default:
      return <NoneControl {...props} />;
  }
}
